import React from 'react';
import clsx from 'clsx';

interface ContentAreaProps {
  className?: string;
  onClick?: () => void;
  text?: string;
  padding?: {
    all?: number;
    top?: number;
    right?: number;
    bottom?: number;
    left?: number;
  };
  state?: 'default' | 'padding';
}

export const ContentArea: React.FC<ContentAreaProps> = ({
  className = '',
  onClick,
  padding = {},
  state = 'default',
}) => {
  const finalPadding = {
    all: padding.all ?? 0,
    top: padding.top ?? 0,
    right: padding.right ?? 0,
    bottom: padding.bottom ?? 0,
    left: padding.left ?? 0,
  };

  return (
    <div
      onClick={onClick}
      className={clsx(
        'bg-neutral-10 relative flex h-[124px] w-full max-w-[216px] items-center justify-center rounded-[20px] p-3 outline outline-offset-[-1px] outline-neutral-100 transition-all',
        className,
      )}
    >
      <div
        className={clsx(
          'relative flex h-[68px] w-[160px] items-center justify-center rounded-lg outline outline-offset-[-1px] transition-all',
          {
            'bg-indigo-50 outline-indigo-300 outline-dashed': state === 'default',
            'bg-neutral-10 outline-neutral-100': state === 'padding',
            'font-medium text-neutral-500': state === 'padding',
            'font-semibold text-neutral-900': state === 'default',
          },
        )}
      >
        <p className={clsx('w-full text-center text-[10px] transition-all')}>{finalPadding.left}</p>

        <div className={clsx('flex h-full flex-col items-center justify-center transition-all')}>
          <p className={clsx('flex h-full items-center justify-center text-[10px] transition-all')}>
            {finalPadding.top}
          </p>

          <div
            className={clsx(
              'flex min-h-5 w-12.5 items-center justify-center rounded border transition-all',
              {
                'bg-neutral-10 border-neutral-200': state === 'default',
                'border-indigo-300 bg-indigo-50': state === 'padding',
              },
            )}
          ></div>

          <p className={clsx('flex h-full items-center justify-center text-[10px] transition-all')}>
            {finalPadding.bottom}
          </p>
        </div>

        <p className={clsx('w-full text-center text-[10px] transition-all')}>
          {finalPadding.right}
        </p>
      </div>
    </div>
  );
};
